// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.159Z

export const cards = [
  {
    "id": "neutral_act_price_list",
    "name_ru": "«Прайс-лист»",
    "name_en": "Price List",
    "faction": "neutral",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Добери 2 карты из колоды"
    },
    "dsl_order": {
      "target": "self",
      "effect": "draw",
      "value": "2"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Кто платит — получает. Кто не платит — становится прайсом.»",
    "ability_text_en": {
      "order": "Draw 2 cards from your deck"
    }
  },
  {
    "id": "neutral_bugay_so_shkvornem",
    "name_ru": "Бугай со шкворнем",
    "name_en": "Goon with a Coupler",
    "faction": "neutral",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 0,
    "hp": 3,
    "keywords": [
      "pierce"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Шкворень тяжёлый — броню гнёт, как фольгу.»"
  },
  {
    "id": "neutral_chumba_truba",
    "name_ru": "«Чумба» с трубой",
    "name_en": "Pal with a Pipe",
    "faction": "neutral",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Труба у него подобрана не от хорошей жизни. Зато бьёт как кувалда.»"
  },
  {
    "id": "neutral_drone_mukha",
    "name_ru": "Дрон-«муха»",
    "name_en": "Fly Drone",
    "faction": "neutral",
    "type": "unit",
    "rarity": "special",
    "archetype": "summon_token",
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 1,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Полчаса сборки на коленке, минуту в полёте — и твоя жизнь стоит дешевле.»"
  },
  {
    "id": "neutral_kontrabandist_dronov",
    "name_ru": "Контрабандист дронов",
    "name_en": "Drone Smuggler",
    "faction": "neutral",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "призвать Дрона-«муху» на случайную ячейку"
    },
    "dsl_order": {
      "target": "own_free_slot",
      "effect": "summon",
      "value": "neutral_drone_mukha"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Эти штуки летают как мухи, бьют как осы. Мне достаточно.»",
    "ability_text_en": {
      "order": "Summon a Fly Drone to a random slot"
    }
  },
  {
    "id": "neutral_sborshik_musora",
    "name_ru": "Сборщик мусора",
    "name_en": "Garbage Collector",
    "faction": "neutral",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 4,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«За пакет хлеба он встанет между тобой и пулей. Дёшево.»"
  },
  {
    "id": "neutral_starik_s_ied",
    "name_ru": "Старик с ИЭД",
    "name_en": "Old Man with IED",
    "faction": "neutral",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "2 урона всем врагам на той же линии"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "enemy_aoe_line",
      "effect": "damage",
      "value": "2"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Он знал, что не вернётся. Зато с ним не вернутся и они.»",
    "ability_text_en": {
      "deathrattle": "2 damage to all enemies on the same line"
    }
  },
  {
    "id": "neutral_ten_s_nozhom",
    "name_ru": "Тень с ножом",
    "name_en": "Shadow with a Knife",
    "faction": "neutral",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 0,
    "hp": 2,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«В трущобах услышать его — последнее, что ты услышишь.»"
  },
  {
    "id": "neutral_ulichnyy_shaman",
    "name_ru": "Уличный шаман",
    "name_en": "Street Shaman",
    "faction": "neutral",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "1 урона выбранному вражескому юниту"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "damage",
      "value": "1"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Молится не богам — диодам. Иногда они слышат.»",
    "ability_text_en": {
      "order": "1 damage to a chosen enemy unit"
    }
  }
];
